import { render } from "./yard.vue?vue&type=template&id=10c07588&scoped=true"
import script from "./yard.vue?vue&type=script&lang=js"
export * from "./yard.vue?vue&type=script&lang=js"

import "./yard.vue?vue&type=style&index=0&id=10c07588&lang=less&scoped=true"

import exportComponent from "E:\\MySite\\XuDAQMS\\xudaqms-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c07588"]])

export default __exports__